import type { BackendInvoiceStatus, InvoicePayUiState, PublicInvoicePay } from '../model/types';

const KNOWN_STATUSES: BackendInvoiceStatus[] = [
  'pending',
  'underpaid',
  'paid',
  'overpaid',
  'expired',
  'error',
];

export const isKnownInvoiceStatus = (status: string | null | undefined): boolean =>
  !!status && KNOWN_STATUSES.includes(status as BackendInvoiceStatus);

export const resolveInvoicePayUiState = (
  invoice: PublicInvoicePay | null,
  options?: { checkingAfterExpiry?: boolean }
): InvoicePayUiState => {
  if (!invoice) return 'LOADING';

  const { status, address, confirmations, txid } = invoice;

  if (!isKnownInvoiceStatus(status)) {
    console.error('[invoice-pay] unknown_invoice_status', { status, invoiceId: invoice.id });
    return 'ERROR';
  }

  if (status === 'error') return 'ERROR';
  if (status === 'expired') return 'EXPIRED';
  if (status === 'paid' || status === 'overpaid') return 'SUCCESS';

  if (options?.checkingAfterExpiry) return 'CONFIRMING';

  const hasAddress = Boolean(address);
  const hasTx = Boolean(txid) || confirmations.current > 0;

  if ((status === 'pending' || status === 'underpaid') && !hasAddress) {
    return 'DETAILS';
  }

  if ((status === 'pending' || status === 'underpaid') && hasTx) {
    if (confirmations.required > 0 && confirmations.current >= confirmations.required) {
      return 'CONFIRMING';
    }
    if (confirmations.current > 0) return 'CONFIRMING';
    return 'PAYMENT_DETECTED';
  }

  return 'PAYMENT';
};

export const isTerminalUiState = (state: InvoicePayUiState): boolean =>
  state === 'SUCCESS' || state === 'EXPIRED' || state === 'ERROR';

export const shouldPollInvoice = (state: InvoicePayUiState): boolean =>
  state === 'PAYMENT' || state === 'PAYMENT_DETECTED' || state === 'CONFIRMING';

export const getPollingIntervalMs = (state: InvoicePayUiState): number => {
  if (state === 'PAYMENT') return 10_000;
  if (state === 'PAYMENT_DETECTED' || state === 'CONFIRMING') return 5_000;
  return 10_000;
};
